jQuery(document).ready(function($){
    
    $.get(ajax.url, {action: 'instagram_feed'}, function(json, textStatus) {
        json = JSON.parse(json);
        if (typeof json === 'object') {
            $.each(json, function(i, foto) {
                $('.instagram-grid').append('<a class="foto" href="' + foto.link + '" title="' + foto.titulo + '" target="_blank" rel="external"><img src="' + foto.miniatura + '" alt="' + foto.titulo + '" /></a>');
            });
        }
    });

    $('.navbar-toggle').unbind('click').on('click', function(){
        $($(this).data('target')).slideToggle();
    });

    function scrollToTarget(target) {
    	targetElement = $(target).length ? $(target) : $('[name=' + target.slice(1) +']');
    	if (targetElement.length) {
    		var offset = targetElement.offset().top - $('header.site-header').height();
    	    $('html, body').animate({
    	        scrollTop: offset
    	    }, 500);
    	    return true;
    	}
    	return false;
    }

    $('a[href*="#"]:not([role="tab"]):not([role="button"])').on('click', function(e){
    	e.preventDefault();
    	scrollToTarget($(this).get(0).hash);
    	return false;
    });

    $('header.site-header .nav-principal a[href*="#"]').off('click').on('click', function(e){
    	if ($('body').hasClass('home')) {
    		e.preventDefault();
    		var href = $(this).attr('href');
    		scrollToTarget(href.slice(href.indexOf('#')));
    		return false;
    	} else {
            /*var home_url = $('header.site-header .logo').attr('href');
            console.log(home_url + $(this).attr('href'));
            window.location = home_url + $(this).attr('href');*/
    		return true;
    	}
    });


    if ($('.cotizar-form').length) {
    	$('.combo-text').attr('disabled', 'disabled');

    	$('input[type="radio"][name="combo"]').on('change', function(){
    		if ($('input[type="radio"][name="combo"][value="Personalizar"]:checked').length > 0) {
    			$('.combo-text').removeAttr('disabled');
                $('.cotizar-personalizar').addClass('visible');
    		} else {
		    	$('.combo-text').attr('disabled', 'disabled');
                $('.cotizar-personalizar').removeClass('visible');
		    }
    	});

    	$('.wpcf7-form').on('submit', function() {
    		if ($('input[type="radio"][name="combo"]:last:checked').length === 0) {
    			$('.combo-text').val('0');
    		} else {
    			var vacios = true;
    			$('.combo-text').each(function(){
    				if ($(this).val() !== '0') {
    					vacios = false;
    				}
    			});
    			if (vacios) {
    				alert('Debe personalizar su pedido.');
    			}
    			return !vacios;
    		}

    	});
    }

    $('ul[role="tablist"] a').on('click', function(e) {
        e.preventDefault();
        $(this).tab('show');
        return false;
    });

    $('.cotizar').on('click', function(e){
        e.preventDefault();
        var numero = $(this).parent().find('.nombre').text().replace('COMBO ', '');
        $('input[type="radio"][name="combo"][value="' + numero + '"]').prop("checked", true);
        $(window).scrollTop(($('.cotizar-form').offset().top - 40) - $('header.site-header').height());
        return false;
    });

    $('select[name="region"] option[value*="Metropolitana"]').prop("selected", true);

});
